import {
  ConfirmLoginMail,
  IncompletePersonalData,
  LegalFooter,
  MDetailRoute,
  MSubheaderPlanner,
  PLoadingItinerary,
  UiModal,
  UiRouteBox,
  UserLoginModal,
} from "libs/raas-ui-react-components/src/components";
import { useContext, useState, useEffect } from "react";
import {
  ConfirmModalLiterals,
  LoginModalLiterals,
  PersonalDataModalLiterals,
  ReactPathNavigation,
  RenfeTrainCodesList,
  getFooterLiterals,
  getResumePath,
  initialDetailLiterals,
  initialDetailLiteralsAtom,
  loadingReturnTripLiterals,
  plannerSubLiterals,
} from "../TripSelector/TripSelector.util";
import { useTranslation } from "react-i18next";
import useSession from "hooks/useSession";
import "./ReturnFromToAve.scss";
import {
  SessionStorageItems,
  getDeviceKey,
  setReturnTripSummaryDetail,
  setStorage,
  setUserDetail,
} from "services/user/user.session.service";
import { getItemStorage } from "services/util/sessionStorage.service";
import { fromToTickets } from "../TripSelector/TripSelector.util";
import { mock } from "../MyTrips/MyTrips.mock";
import { useNavigate } from "react-router-dom";
import useToast from "hooks/useToast";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { getUserData } from "services/user/user-micros.service";
import { openMail } from "pages/public/RegistroUser/RegisterUser.service";
import { formatPrice } from "services/util/trips.service";
import { IBodyTripSelected, ITripSelectedDetails, Leg, LegList, Stop, TariffResult, Trip } from "models/TripInterface";
import { TripDetail, isEmptyArray } from '../TripSelector/TripSelector.service';
import { PlanningObject } from "pages/public/Planner/PlannerFlow.model";
import { emptyArray } from "services/util/util.service";
import { getPromiseByProvider } from "services/user/user-login-social.service";
declare const window: any;
export const ReturnFromToAve = () => {
  //comunicaciones con otras pantallas y ficheros
  const [t] = useTranslation("tripSelector");
  const navigate = useNavigate();
  const { openToast } = useToast();

  const {
    userConnected,
    logged,
    tripSelectedDetails,
    tripReturnSelectedDetails,
    setFleetKarhooName,
    setSession,
    setLogged,
    setUserConnected,
    setTripSelectedDetails,
    setReturnTripSelectedDetails,
  } = useSession(); // de aqui info user
  const aveSectionDefaultValue = {
    isAveSelected: false,
    aveTripList: [],
    payedPassengerNumber: 0,
    summarySection: { otherTransportPrice: 0, aveSummaryList: [] },
  };
  //Literales
  const [plannerSubLiteralsData] = useState(plannerSubLiterals(t));
  const [detailLiterals] = useState(initialDetailLiterals(t));
  const [detailLiteralsAtom] = useState(initialDetailLiteralsAtom(t));
  const [footerLiterals] = useState(getFooterLiterals(t));

  //States Booleans
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginToken, setLoginToken] = useState();
  const [fakeLoadingSemaphore, setFakeLoadingSemaphore] = useState(true);

  //States Numbers
  const [step, setStep] = useState(0);


  //States Strings
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const [departureAveSection, setIsAveSelected] = useState(
    aveSectionDefaultValue
  );
  let [returnAveSection, setIsReturnAveSelected] = useState(
    aveSectionDefaultValue
  );

  //DataObjects
  const [planningObject, setPlanningObject] = useState({} as any);
  const [fromToRouteBox, setFromToRouteBox] = useState({} as any);
  const [detailsSelector, setDetailSelector] = useState([] as any[]);
  const [detailPriceTotal, setDetailPriceTotal] = useState({
    sum: 0,
    desc: " 0 €",
  } as { sum: number; desc: string });
  const [travellersList, setTravellersList] = useState([] as any);


  useEffect(() => {
    getReturnFromToAveDetailAndRouteBox();
    let body = getSessionQuery();
    if (body === null) navigate("/plan");
    setTimeout(() => {
      setFakeLoadingSemaphore(false)
    }, 5000);
  }, []);

  const okLogin = (data: any) => {
    setSession(data);
    setStorage(data);
    setLogged(true);
    getData();
  };

  const _makeTravellersList = (planningObject: PlanningObject) => {
    const passengersList = planningObject?.passengers?.value;
    const passengerMapped = {
      adult: Array(passengersList["more-than-13-counter"]).fill({
        type: "ADULT",
      }),
      child: Array(passengersList["less-than-13-counter"]).fill({
        type: "CHILD",
      }),
      baby: Array(passengersList["less-than-3-counter"]).fill({ type: "BABY" }),
    };
    const travellersBody = passengerMapped?.adult.concat(
      passengerMapped?.child,
      passengerMapped?.baby
    );
    setTravellersList(travellersBody);
    return travellersBody;
  };

  const getData = () => {
    getUserData(
      (response: any) => {
        const userDataResponse = response?.data;
        setUserDetail(userDataResponse);
        setUserConnected(userDataResponse);
        const missingMandatoryInfo = userDataResponse?.missingMandatoryInfo;
        const path = "/ave-stepper-page?goBackTo=/return-ave";

        missingMandatoryInfo ? setStep(2) : navigate(path);
      },
      () => {
        openToast("error", "Error", t("literals.tryAgainLater"));
      }
    );
  };

  const callLoginMicroService = (data: { email: string; password: string }) => {
    setEmail(data?.email);
    setPass(data?.password);
    let loginBody = {
      username: data?.email,
      password: data?.password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          window.dataLayer?.push({
            event: "login",
            method: "email"
          });
          openToast(
            "success",
            t("literals.sendEmail"),
            t("literals.findYourCodeIn") + t("literals.yourEmail") + data?.email
          );
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        let literal = t("literals.anErrorOccurred");
        openToast("error", t("literals.error"), literal);
      });
  };

  const handleReSendEmail = () => {
    openToast(
      "success",
      t("literals.sendEmail"),
      t("literals.findYourCodeIn") + t("literals.yourEmail") + email
    );
    let loginBody = {
      username: email,
      password: password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        // TODO literles porne en todos los idiomas esta solo en español
        let literal = t("literals.anErrorOccurred");
        openToast("error", "Error", literal);
      });
  };

  const hadleVerifyMail = (data: any) => {
    const code = data?.detail;
    let verifyBody = {
      token: loginToken,
      email,
      code,
    };
    postAxios(
      apiNames.IDENTITY,
      false,
      "/sessions/verification-code",
      verifyBody
    )
      .then((response: any) => {
        if (response?.status === 206) {
          setLoginToken(response?.data?.token);
          openToast("error", "Error", t("literals.incorrectCode"));
        } else {
          if (document.body.style?.overflow === 'hidden') {
            document.body.style.overflow = "auto";
          }
          okLogin(response?.data);
        }
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          openToast("error", "Error", t("literals.incorrectCode"));
        } else if (error.status === 401) {
          openToast("error", "Error", t("literals.wrongEmailPassword"));
          setStep(0);
        }
      });
  };
  const handleOpenMail = () => {
    openMail(email);
  };
  const checkNavigateNext = () => {
    if (logged) {
      const missingMandatoryInfo = userConnected?.missingMandatoryInfo;
      // force mandatory info
      if (missingMandatoryInfo) {
        openMissingMandatoryInfoModal();
        return;
      } else {
        navigateNext();
      }
    } else {
      setShowLoginModal(true);
    }
  };

  const navigateNext = () => {
    const path = "/ave-stepper-page?goBackTo=/return-ave";
    navigate(path);
  };

  const openMissingMandatoryInfoModal = () => {
    setStep(2);
    setShowLoginModal(true);
  };

  const getReturnFromToAveDetailAndRouteBox = () => {
    const returnDetail = getItemStorage(
      SessionStorageItems.RAAS_RETURN_FROM_TO_AVE
    );
    const returnRouteBox = getItemStorage(
      SessionStorageItems.RAAS_RETURN_FROM_TO_ROUTE_BOX
    );

    setDetailSelector(returnDetail);
    setFromToRouteBox(returnRouteBox);

    calcCurrentPrice(returnDetail);
  };

  const getSessionQuery = () => {
    const query = getItemStorage(SessionStorageItems.TRIP);
    if (query) {
      setPlanningObject({ ...query, trip: 'RETURN' });
      _makeTravellersList(query);
    }
    return query;
  };

  const handleClickRouteBox = () => {
  };

  const getDate = () => {
    const date = new Date(planningObject?.arrivalDate?.value);
    const dateWithFormat = date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    return {
      returnDate: dateWithFormat,
    };
  };

  const getPassengerNumberByCode = (code: string) => {
    const passengerObj = planningObject?.passengers?.value;
    return passengerObj[code];
  };

  const getPassengerNumber = (): number => {
    const passengerObj = planningObject?.passengers?.value;
    const passagerNumberArray = Object.values(passengerObj);
    const sum: number = passagerNumberArray.reduce(
      (prev: any, current: any) => prev + current,
      0
    ) as number;
    return sum;
  };

  const mapSummaryAveStepper = (aveList: any): any => {
    const allPassenger = getPassengerNumber();
    const dateObject = getDate();

    const summary = (aveList || []).map((item: any) => {
      const childTarif = (!!item?.childTarif && !emptyArray(item?.childTarif)) ? item?.childTarif[0] : null;

      const totalTicketPrice = item?.priceTag?.price;

      return {
        origin: item?.origin,
        direction: item?.direction,
        allPassengerTicketPrice: totalTicketPrice,
        childTarif: childTarif,
        adultTarif: item?.tarifSelected,
        allPassangerNum: allPassenger,
        aveName: item?.aveName,
        arrivalTime: item?.arrivalTime,
        departureTime: item?.departureTime,
        //fullDepartureDate: getDepartureDate(item?.departureDate),
        fullDepartureDate: item?.departureDate,
        isSilentCar: item?.isSilentCar,
        ...dateObject
      }
    });
    return summary;
  };

  const getDiscountList = (tarifsArray: any, discuntCode: string) => {
    return tarifsArray?.filter(
      (item: any) =>
        item?.group?.type === discuntCode &&
        item?.group?.child === false &&
        !!item?.group?.discount
    );
  };

  const getChildTarif = (tarifsArray: any, discuntCode: string) => {
    return tarifsArray?.filter(
      (item: any) =>
        item?.group?.type === discuntCode &&
        item?.group?.child === true &&
        !item?.group?.discount
    );
  };

  const aveMapSection = (aveList: any) => {
    return (aveList || []).map((item: any) => {
      const stopsArray = item?.stops;
      let firstStop = !!stopsArray ? stopsArray[0] : "";
      let lastStop = !!stopsArray ? stopsArray.slice(-1)[0] : "";
      const tarifSelected = item?.tarifs?.find((ta: any) => ta?.shpCtx === item?.pricetag?.shpCtx);
      const discountList = getDiscountList(item?.allTarifsList, tarifSelected?.group?.type);
      const childTarif = getChildTarif(item?.allTarifsList, tarifSelected?.group?.type);
      return {
        title: t("literals.back"),
        discountList: discountList,
        tarifSelected: tarifSelected,
        childTarif: !isEmptyArray(childTarif) ? childTarif : [tarifSelected].filter(Boolean),
        origin: firstStop,
        direction: lastStop,
        aveName: item?.line?.text,
        priceTag: item?.pricetag,
        arrivalTime: item?.arrivalTime,
        departureTime: item?.departureTime,
        departureDate: item?.departureDate,
        isSilentCar: item?.pricetag?.isSilentCar
      }
    });
  };

  const _checkIfTripIncludeAVE = (
    ev: CustomEvent
  ): void => {
    const transport = ev.detail;
    const includesAve = transport.filter((elem: any) => elem?.icon === "ave");
    const notAveTransport = transport.filter((elem: any) => elem?.icon !== "ave");
    const aveMap = aveMapSection(includesAve);
    const adultNumber = getPassengerNumberByCode("more-than-13-counter");
    const childNumber = getPassengerNumberByCode("less-than-13-counter");
    const payedPassengerNumber = adultNumber + childNumber;

    const isAve = includesAve?.length > 0;
    const otherTransportPrice = notAveTransport?.reduce((prev: any, current: any) => {
      return prev + current?.pricetag?.price
    }, 0);

    const summaryReturn = mapSummaryAveStepper(aveMap);
    returnAveSection = {
      payedPassengerNumber,
      isAveSelected: isAve,
      aveTripList: aveMap,
      summarySection: {
        otherTransportPrice: Number(otherTransportPrice),
        aveSummaryList: summaryReturn
      }
    };
    setIsReturnAveSelected(returnAveSection);
  };


  const revertLegList = (leg: Leg[]): Leg[] => {
    let _listReverted: Leg[] = [];
    let notPush: boolean = false;
    for (let i = leg.length - 1; i >= 0; i--) {
      if (leg?.[i]?.type === "JNY" && leg?.[i - 1]?.type === "CHKI") {
        _listReverted.push(leg[i - 1]);
        _listReverted.push(leg[i]);
        notPush = true;
      }
      if (leg?.[i]?.type !== "CHKI" && !notPush) {
        _listReverted.push(leg[i]);
      }
      notPush = false;
    }
    return _listReverted;
  }

  const reverseStops = (stopsArray: Array<Stop>) => {
    if (Array.isArray(stopsArray) && stopsArray.length > 0) {
      return stopsArray.reverse();
    }
    return stopsArray;
  }

  const _getLegListReturnBoby = (LegList: any, detailsSelector: any) => {
    const { Leg } = LegList;
    const legReverted = revertLegList(Leg);
    const departureLegListReversed = legReverted?.filter((item: any) => item?.category === "107");
    const updateDateLegList = departureLegListReversed?.map((item: any) => {
      const pstDetail = detailsSelector[0];
      const origin = { ...item.Origin };
      const destination = { ...item.Destination };
      const Stop = reverseStops(item?.Stops?.Stop);
      return {
        ...item,
        Stops: { Stop },
        Origin: {
          ...destination,
          date: pstDetail?.departureDate,
          time: pstDetail?.departureTime + ':00'
        },
        Destination: {
          ...origin,
          date: pstDetail?.departureDate,
          time: pstDetail?.arrivalTime + ':00'
        }
      }
    })
    return { Leg: updateDateLegList };
  }

  const _getTripBody = () => {
    const departureTrip = fromToRouteBox?.departureTrip;
    const departureDetails = detailsSelector[0];
    const departureDetailsLast = detailsSelector[detailsSelector.length - 1]

    return {
      Destination: { ...departureTrip?.Origin, date: departureDetails.departureDate, time: departureDetailsLast.arrivalTime + ':00' },
      LegList: _getLegListReturnBoby(departureTrip?.LegList, detailsSelector),
      Origin: { ...departureTrip?.Destination, date: departureDetails.departureDate, time: departureDetails.departureTime + ':00' },
      TariffResult: departureTrip?.TariffResult,
      checksum: departureTrip?.checksum,
    }
  }

  function getContextPerPassenger(shpCtx: string, travellerList: any) {
    const tickets: Array<any> = [];

    travellerList.forEach((item: any) => {
      if (item?.type !== "BABY") {
        tickets.push({ context: shpCtx })
      }
    })
    return tickets;
  }

  function getProvider(train: any) {
    return RenfeTrainCodesList.includes(train?.trip?.Product[0]?.matchId) ? 'renfe-ave' : ""
  }

  const _getSelectedTariffBody = () => {
    const array = detailsSelector?.map((item: any) => {
      return {
        idLeg: +item.idPst,
        provider: getProvider(item),
        contextType: "BOOKEE_CONTEXT",
        tickets: getContextPerPassenger(item?.realPriceTag?.shpCtx, travellersList),
        notes: []
      }
    })
    return array;
  }

  const _makeOutwardJourneySection = () => {
    return {
      trip: _getTripBody(),
      selectedTariff: _getSelectedTariffBody()
    }
  };

  const _makeSaveTripBody = () => {
    const key = "returnJourney";

    return {
      [key]: _makeOutwardJourneySection(),
      travellers: travellersList,
    };
  };

  const _makeSummaryDetails = () => {
    const passagerNumberArray: Array<number> = Object.values(
      planningObject?.passengers?.value
    );
    const sum = passagerNumberArray.reduce(
      (prev, current) => prev + current,
      0
    );

    const date = new Date(planningObject?.arrivalDate?.value);
    let firstItem = detailsSelector[0];
    let lastItem = detailsSelector.slice(-1)[0];
    const textLiteral = t("literals.back");
    return [
      {
        text: textLiteral,
        price: detailPriceTotal?.desc,
        priceNumber: detailPriceTotal?.sum,
        departure: planningObject?.destination?.value?.name,
        arrival: planningObject?.origin?.value?.name,
        date: date.toLocaleDateString("es-ES", {
          month: "short",
          day: "2-digit",
        }),
        rangetime: `${firstItem?.departureTime} - ${lastItem?.arrivalTime}`,
        num: String(sum),
        totalPriceWithoutExtras: detailPriceTotal?.sum
      },
    ];
  };

  const _getTextDetails = (item: TripDetail) => {
    return item.isExternal
      ? t("literals.ticketStation") + `${item?.stops ? item?.stops[0] : ""}` : `${item?.line?.text} ${item?.direction}`
  }

  const _makeSummaryAmount = (ev: CustomEvent): any => {
    const transportList: TripDetail[] = ev.detail;
    const onlyTransportList = transportList.filter((item) => item.transport);
    const aproxList = onlyTransportList.filter(
      (item) => item.isAproximetePriceElement
    );
    const aproxAmount = aproxList.reduce(
      (prev, current) => prev + current?.pricetag?.price,
      0
    );
    const nowToPay = detailPriceTotal?.sum - aproxAmount;
    const key = "arrival";
    let resultPrice = ""

    return {
      [key]: {
        desglose: {

          now: `${formatPrice(nowToPay)} €`,
          later: `${!!aproxAmount ? t("literals.approxPoint") : ""} ${formatPrice(aproxAmount)} €`,
          total: `${!!aproxAmount ? t("literals.approxPoint") : ""} ${detailPriceTotal?.desc}`,
          aproxPrice: aproxAmount
        },
        transports: onlyTransportList.map(item => {
          const pricetag = item?.pricetag;
          const transport = item?.icon;
          if (pricetag.price === null && (transport === "metro" || transport === "cercanias")) {
            resultPrice = item?.pricetag?.text
          }
          else if (pricetag.price !== 0) {
            resultPrice = formatPrice(pricetag.price) + "€";
          }
          else if (item?.isExternal && item?.realPriceTag.price === 0 && pricetag.text.includes(t("literals.requiresExternalPurchaseNoPrice"))) {
            resultPrice = t("literals.requiresExternalPurchaseNoPrice")
          }
          else if (item?.isExternal && item?.realPriceTag.price !== 0) {
            resultPrice = t(formatPrice(item?.realPriceTag.price)) + "€";
          }
          else if (pricetag.text.includes(t("literals.includedTicket"))) {
            resultPrice = t("literals.includedTicket")
          }
          else {
            resultPrice = `${t("literals.includedTicket")}.`;
            // resultPrice = "" // controlar posibles casuisticas no cubiertas.
          }

          return item?.isAproximetePriceElement || item?.isCarTransport
            ? { transport: item.transportTypeString, price: `${item?.isAproximetePriceElement ? t("literals.approxPoint") : ""} ${formatPrice(item?.pricetag?.price)} €` }
            : {
              idLeg:item?.idPst.replace(/[^0-9]+/g, ""),
              idTariff:item?.idTariff,
              informative:item?.pricetag?.informative===undefined ?false:true,
              color:item?.line?.backgroundcolor,
              line:item?.line?.text,
              icon:item?.line?.icon,
              route:item?.trip?.Origin?.name,
              destiny:item?.trip?.Destination?.name,  
              departureTime:item?.departureTime,
              arrivalTime:item?.arrivalTime,
              departureDate:item?.departureDate,
              transport: 'RENFE',
              isIncluding:false,
              bonoAveFree:item?.realPriceTag?.bonoAveFree || false,
              key:key, 
              priceNumber:item?.pricetag?.price,
              totalPriceWithoutExtras:item?.realPriceTag?.price,
              passager: getPassengerNumber(),
              price: `${item?.isAproximetePriceElement ? t("literals.approx") : ""} ${formatPrice(item?.pricetag?.price)} €`,
              isPaidTrip:false,
              details: [
                {
                  icon: item?.icon,
                  text: _getTextDetails(item),
                  external: item?.isExternal,
                  price: resultPrice,
                  //price: `${item?.pricetag?.price !== 0 ? formatPrice(item?.pricetag?.price) + "€": t("literals.includedTicket")} `,
                },
              ],
            };
        }),
      },
    };
  };

  const _setTripResumeDetailsInfo = (ev: CustomEvent): void => {
    _checkIfTripIncludeAVE(ev);
    const bodySection: IBodyTripSelected = _makeSaveTripBody();
    const summarySection = _makeSummaryDetails();

    const tripSummaryDetails: ITripSelectedDetails = {
      body: bodySection,
      summary: summarySection,
      summaryAmount: _makeSummaryAmount(ev),
      aveDeparture: departureAveSection,
      aveReturn: returnAveSection,
    }
    setReturnTripSelectedDetails(tripSummaryDetails);
    setReturnTripSummaryDetail(tripSummaryDetails);
  }

  const handleSelectRoute = (ev: CustomEvent) => {

    _setTripResumeDetailsInfo(ev);
    checkNavigateNext();
  };

  const goToProfile = () => {
    navigate("/personal-data?goTo=/trip");
  };

  const calcCurrentPrice = (returnDetailList: any): void => {
    const initialValue = 0;
    const sumWithInitial = returnDetailList?.reduce(
      (previousValue: any, currentValue: any) =>
        previousValue + currentValue?.pricetag?.price || 0,
      initialValue
    );
    const twoDecimal = +sumWithInitial.toFixed(2);
    const totalObject = {
      sum: twoDecimal,
      desc: formatPrice(sumWithInitial) + " €",
    };
    setDetailPriceTotal(totalObject);
  };

  const handleLoginSocial = ({ detail }: CustomEvent) => {
    window.dataLayer?.push({
      event: "select_content",
      screen_name: 'welcome',
      screen_class: 'onboarding',
      content_name: 'social_login',
      content_type: detail,
    });
    getPromiseByProvider(detail);
  }


  const getModalSlot = (currentStep: number) => {
    switch (currentStep) {
      case 0:
        return (
          <UserLoginModal
            literals={JSON.stringify(LoginModalLiterals(t))}
            react-path-navigation={JSON.stringify(ReactPathNavigation)}
            onCloseModal={() => setShowLoginModal(false)}
            onLoginEventClick={(e: any) => callLoginMicroService(e.detail)}
            onNavigateToEventClick={(e: any) => navigate(e.detail)}
            onLoginSocialClicked={handleLoginSocial}
          ></UserLoginModal>
        );
      case 1:
        return (
          <ConfirmLoginMail
            literals={JSON.stringify(ConfirmModalLiterals(t))}
            mail={email}
            onResendMail={handleReSendEmail}
            onOpenMail={handleOpenMail}
            onVerifyEmail={hadleVerifyMail}
            onBackPage={() => setStep(0)}
            onCloseModal={() => setShowLoginModal(false)}
          />
        );
      case 2:
        return (
          <IncompletePersonalData
            literals={JSON.stringify(PersonalDataModalLiterals(t))}
            onCancelClickEvent={() => setShowLoginModal(false)}
            onGoToProfileClickEvent={() => goToProfile()}
          />
        );
    }
  };

  return (
    <>
      {fakeLoadingSemaphore ? (
        <PLoadingItinerary
          literals={JSON.stringify(loadingReturnTripLiterals(t))}
        ></PLoadingItinerary>
      ) : (
        <div className="return-fromto-ave-container">
          <div className="sub-header-container">
            <MSubheaderPlanner
              plannigObject={planningObject}
              literals={plannerSubLiteralsData}
              disableOpenOption={true}
              hasReturn="false"
            ></MSubheaderPlanner>
          </div>
          <div className="return-fromto-content">
            <h1 className="trip-title">{t("chooseBackAveTrip")}</h1>
            <div className="return-fromto-datacontainer">
              <div className="return-fromto-routebox">
                <UiRouteBox
                  fromToSelected={true}
                  onClickRouteBox={() => handleClickRouteBox()}
                  tripOptions={fromToRouteBox?.tripOptions}
                  isFromTo={true}
                ></UiRouteBox>
                <div className="section-mitma">
                  <span className="text-mitma">Powered by </span>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.mitma.es/"
                    className="text-mitmaLink"
                  >
                    MITMA
                  </a>
                </div>
              </div>
              <div className="return-fromto-details">
                <MDetailRoute
                  scrollinside={true}
                  showBuyButton={true}
                  isAveReturn={true}
                  showDetailInfo={true}
                  detailPrice={detailPriceTotal}
                  literals={detailLiterals}
                  detailLiterals={detailLiteralsAtom}
                  detailData={detailsSelector}
                  onSelectedRoute={(ev: CustomEvent) => handleSelectRoute(ev)}
                ></MDetailRoute>
              </div>
            </div>
          </div>
          <div>
            <LegalFooter literals={footerLiterals} fixed></LegalFooter>
          </div>
          <UiModal
            open={showLoginModal}
            blockOverlay={true}
            onModalClosed={() => setShowLoginModal(false)}
            notUseShiftLogic={true}
          >
            {getModalSlot(step)}
          </UiModal>
        </div>
      )}
    </>
  );
};

